import { computed } from 'vue';

import type { UserListItem } from '@stuut/api-sdk/models';

import { useProfile } from '@/store';

import { useHasSharedInbox } from './useHasSharedInbox';
import { useUsersList } from './useUsers';

export function useCoveringUsers() {
  const profileStore = useProfile();
  const usersQuery = useUsersList();
  const { value: isOooEnabled } = useHasSharedInbox();

  const coveredUsers = computed<UserListItem[]>(() => {
    if (!isOooEnabled.value) return [];
    const currentUserId = profileStore.profile?.id;
    if (!currentUserId) return [];
    return (usersQuery.data.value?.data ?? []).filter(
      (u) => u.isOoo && u.backupUserId === currentUserId,
    );
  });

  const coveredUserIds = computed<Set<string>>(() => new Set(coveredUsers.value.map((u) => u.id)));

  const isCovering = computed(() => coveredUsers.value.length > 0);

  return { coveredUserIds, coveredUsers, isCovering };
}
